import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const ChangePassword = ({ forced, onDone }) => {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const cls = "mt-2 w-full border-b border-[#1c1418]/30 bg-transparent py-3 text-lg outline-none focus:border-[#1c1418]";

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("Le due nuove password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password aggiornata");
      setUser({ ...user, must_change_password: false });
      onDone?.();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="change-password-form" className="mx-auto w-full max-w-md space-y-6">
      {forced && <p className="bg-[#f4f4f4] p-4 text-sm">Primo accesso: scegli la tua password personale per continuare.</p>}
      {[["current_password", "Password attuale"], ["new_password", "Nuova password (min 8)"], ["confirm", "Ripeti nuova password"]].map(([k, l]) => (
        <label key={k} className="block font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/70">{l}
          <input type="password" required minLength={k === "current_password" ? 1 : 8} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })}
            data-testid={`change-password-${k}`} className={cls} />
        </label>
      ))}
      <button disabled={busy} data-testid="change-password-submit" className="w-full bg-[#1c1418] py-4 font-mono text-xs uppercase tracking-[0.25em] text-white disabled:opacity-60">
        {busy ? "Salvataggio…" : "Salva nuova password"}
      </button>
    </form>
  );
};
